import {
  RoadmapBuildingYearDTO,
  RoadmapPortfolioDetailsTotalDTO,
  RoadmapPortfolioDetailsTotalEnergyLabelsDTO
} from 'csr-asset-app';
import { LabelChartTableInterface } from '../interfaces';

export function mapLabels(year: string, label: string, total: number): LabelChartTableInterface {
  return {
    year: year,
    'A+++': label !== 'A+++' ? '' : total,
    'A++': label !== 'A++' ? '' : total,
    'A+': label !== 'A+' ? '' : total,
    A: label !== 'A' ? '' : total,
    B: label !== 'B' ? '' : total,
    C: label !== 'C' ? '' : total,
    D: label !== 'D' ? '' : total,
    E: label !== 'E' ? '' : total,
    F: label !== 'F' ? '' : total,
    G: label !== 'G' ? '' : total
  };
}

export function mapToTableHeaders(labelsByYear: { [p: string]: RoadmapPortfolioDetailsTotalEnergyLabelsDTO[] }): {
  [key: string]: LabelChartTableInterface[];
} {
  const years: string[] = Object.keys(labelsByYear);

  const currentDataIndex: number = 1;
  const improvedDataIndex: number = 0;

  const current: LabelChartTableInterface[] = mapLabelsCartTable(years, labelsByYear, currentDataIndex);
  const improved: LabelChartTableInterface[] = mapLabelsCartTable(years, labelsByYear, improvedDataIndex);

  return { current, improved };
}

function mapLabelsCartTable(
  years: string[],
  labelsByYear: { [p: string]: RoadmapPortfolioDetailsTotalEnergyLabelsDTO[] },
  currentOrImprovedIndex: number
): LabelChartTableInterface[] {
  return years.map((year: string): LabelChartTableInterface => {
    const label: string = labelsByYear[year][currentOrImprovedIndex].label.label;
    const total: number = labelsByYear[year][currentOrImprovedIndex].total;
    return mapLabels(year, label, total);
  });
}

export function mapBuildingDetailYearResultsNumbers<T extends RoadmapPortfolioDetailsTotalDTO | RoadmapBuildingYearDTO>(
  yearData: T
): T {
  Object.entries(yearData).forEach(
    (data: [keyof RoadmapPortfolioDetailsTotalDTO | keyof RoadmapBuildingYearDTO, number]) => {
      if (data[0] === 'year' || data[0] === 'energyLabels') {
        return;
      }

      if (data[1] === null) {
        return;
      }

      yearData[data[0]] = +data[1].toFixed(2);
    }
  );
  return yearData;
}
